import type { NodeConfig } from "../schemas/index.ts";
import type { DirectReferenceVariableConfig, ReferenceVariableConfig } from "../types/index.ts";

export const isReferenceVariable = (value: unknown): value is ReferenceVariableConfig =>
  !!value && typeof value === "object" && "type" in value && value.type === "reference";

export const isDirectReferenceVariable = (value: unknown): value is DirectReferenceVariableConfig =>
  isReferenceVariable(value) && "refId" in value;

export const decomposeReferenceVariable = (config: DirectReferenceVariableConfig) => {
  if (!("refId" in config)) {
    throw new Error(`Role based reference variables not supported in import/export`);
  }

  const [nodeIdStr, name] = config.refId.split(":");
  return {
    nodeId: Number(nodeIdStr),
    name,
  };
};

export const composeReferenceVariable = (nodeId: number, name: string): DirectReferenceVariableConfig => ({
  type: "reference",
  refId: `${nodeId}:${name}`,
});

export const hasVariableConfigs = (
  config: NodeConfig,
): config is Omit<NodeConfig, "variables"> & Required<Pick<NodeConfig, "variables">> =>
  "variables" in config && typeof config.variables === "object";

export const hasNodeReferences = (config: NodeConfig): config is Required<Pick<NodeConfig, "nodeReferences">> =>
  "nodeReferences" in config && typeof config.nodeReferences === "object";
